import useCurrentTradeContext from './useCurrentTradeContext';
import { TradeContext } from '../../types/trade';

const useIsSellContext = () => useCurrentTradeContext() === TradeContext.Sell;

export default useIsSellContext;
